<template>
  <div class="cc-select-store" @click.prevent.stop>
    <div class="cc-select-store__header" @click.stop="$emit('onShowBranches')">
      <div class="cc-select-store__title mb-2" v-if="selectedStore">{{ currentCarrier.name }}</div>
      <button class="cc-button cc-button--delivery-branch btn btn-primary">
        {{ deliveryBranchButtonName }}
      </button>
    </div>
    <div class="cc-select-store__main" v-if="showBranches">
      <div class="cc-popup cc-popup--with-overlay" v-bind:class="{'cc-show': showBranches}"
           @mousedown.self.prevent.stop="closePopup">
        <div class="cc-popup__content">
          <div class="cc-popup__header">
            <div class="cc-popup__title">
              <span>{{ translations['Select store'] }}</span> <img :src="config.logo" class="cc-shop-logo" />
            </div>
          </div>
          <div class="cc-popup__main">
            <div class="row">
              <div v-for="carrier in carriers" v-bind:key="carrier.id_carrier">
                <div class="col-lg-6">
                  <div class="branch-button" @click="$emit('selectCarrier', carrier)">
                    <input class="d-inline-block m-1" type="radio" :checked="currentCarrier && currentCarrier.id_carrier === carrier.id_carrier"/>
                    <span class="d-inline-block my-1 branch-button-label">{{ carrier.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cc-popup__close-button-wrapper">
            <span class="cc-popup__close-button" @click.stop="closePopup">✕</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      translations: state => state.translations,
      config: state => state.config,
    }),
    deliveryBranchButtonName: function () {
      return this.selectedStore ? this.translations['Change'] : this.translations['Select branch'];
    },
    selectedStore: function () {
      return this.carriers.filter(carrier => this.selectedCarrier === carrier.id_carrier).length > 0;
    },
  },
  methods: {
    closePopup: function () {
      if (!this.currentCarrier) {
        this.$emit('closeWithoutParcelShop');
        return;
      }
      this.$emit('close');
    }
  },
  props: [
    'carriers',
    'selectedCarrier',
    'showBranches',
    'currentCarrier',
  ],
};
</script>

<style lang="scss" scoped="scoped">
@import "../../_common/scss/popups";
@import "../../_common/scss/tables";

.cc-button {
  white-space: nowrap;
}

#app .cc-popup__content {
  min-width: 600px;
}

.branch-button {
  cursor: pointer;
  border: 2px solid #ced4da;
  text-align: left;
}

#app .cc-popup__title {
  display: block;
}

#app .cc-popup__header {
  text-align: left;
}
.cc-shop-logo {
  margin: 0 1rem;
}
.cc-popup__close-button-wrapper {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.cc-popup__close-button {
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
}
</style>
